export default __webpack_public_path__ + "static/media/page_of_cups.95dfcafd.png";